import { GetStaticPropsContext } from 'next';
import { useIntl } from 'react-intl';

import { Duration } from 'constants/duration.constants';
import Prefetcher from 'services/prefetcher';

import PageSeo from 'components/@seo/PageSeo';
import UnsupportedDeviceContainer from 'components/@support/UnsupportedDeviceContainer';

const UnsupportedDevice = () => {
  const intl = useIntl();
  return (
    <>
      <PageSeo
        title={intl.formatMessage({ id: 'unsupported_device.seo_title' })}
        description={intl.formatMessage({
          id: 'unsupported_device.seo_description',
        })}
        noindex
        nofollow
      />
      <UnsupportedDeviceContainer />
    </>
  );
};

export default UnsupportedDevice;

export const getStaticProps = async ({
  locale,
  preview,
}: GetStaticPropsContext) => {
  const prefetcher = await Prefetcher.init({ locale, preview });

  return {
    props: {
      dehydratedState: prefetcher.dehydratedState,
    },
    revalidate: Duration.TEN_MIN,
  };
};
